<template>
  <div>
    <div class="page-main has-bottom">
      <page-title />
      <div class="init-page">
        <page-card>
          <template slot="header">
            New Well Information
          </template>
          <div slot="body" v-loading="loading">
            <wellComp ref="addWellComp" :removeDisabled="true" />
          </div>
        </page-card>
      </div>
    </div>
    <page-bottom>
      <template>
        <div class="page-btns">
          <el-button @click="goback">Cancel</el-button>
          <loading-btn label="Submit" type="primary" @clickHandle="submit" />
        </div>
      </template>
    </page-bottom>
  </div>
</template>

<script>
import wellComp from "./components/well.vue";
export default {
  components: {
    wellComp,
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {},
  methods: {
    goback() {
      this.$router.push("/wellManagement/myWells");
    },
    submit(btn) {
      // this.$refs.addWellComp.check().then(res => {
      //   this.loading = true;

      // }).catch(err => {
      //   this.$message.error("The well you added already exists!");
      //   console.log(err)
      //   this.loading = false;
      //   btn.closeLoad();
      // })
      this.loading = true;
      this.$refs.addWellComp.submit().then(res => {
        this.$message.success("add measurementPoint info is completed!");
        btn.closeLoad();
        this.loading = false;
        this.goback();
      }).catch(err => {
        console.log(err)
        this.loading = false;
        btn.closeLoad();
      })
    }
  },
  created() { },
  mounted() { }
};
</script>
<style scoped>

</style>
